import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpSection, HeaderAction, SearchBasicInfo, SearchMode, SearchOptionType, SearchRowInfo } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { Alias } from '../../models/alias';
import { AliasService } from '../../services/alias.service';
import { AliasTableService } from '../table/alias-table.service';
import { AliasHeaderService } from './alias-header.service';


@Component({
  selector: 'app-alias-header',
  templateUrl: './alias-header.component.html'
})
export class AliasHeaderComponent implements OnChanges, OnInit, OnDestroy {
  @Input() alias: Alias[] = [];
  @Output() filtersChanged = new EventEmitter<Filter[]>();

  leftActions: HeaderAction[] = [];
  rightActions: HeaderAction[] = [];

  showSearch = false;
  private readonly title = 'alias-config.alias-row.title';
  private readonly tooltip = 'alias-config.alias-row.tooltip';
  section = new DpSection({ name: 'alias', rows: [], header: this.title, tooltip: this.tooltip });
  searchAvailableOptions: SearchRowInfo[] = [];
  private filters: Filter[] = [];
  private aliasChangedSubscription?: Subscription;


  constructor(
    private readonly aliasHeaderService: AliasHeaderService,
    private readonly aliasTableService: AliasTableService,
    private readonly aliasService: AliasService,
    private readonly searchService: SearchService,
    private readonly cloudService: CloudService
  ) {

    this.searchAvailableOptions = this.getSearchAvailableOptions();

    this.rightActions = this.aliasHeaderService.getRightActions();
    const searchAction = this.aliasHeaderService.getSearchAction(this.rightActions);

    searchAction.action = () => {
      this.showSearch = !this.showSearch;
    };

  }

  private getSearchAvailableOptions(): SearchRowInfo[] {

    const searchAvailableOptions: SearchRowInfo[] = [];

    searchAvailableOptions.push(new SearchRowInfo(true, 'alert_alias', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true));
    searchAvailableOptions.push(new SearchRowInfo(false, 'email', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true));
    if (!this.cloudService.isModeCloud()) {
      searchAvailableOptions.push(new SearchRowInfo(false, 'phone_number', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true));
    }

    return searchAvailableOptions;

  }

  ngOnInit(): void {
    if (!this.aliasChangedSubscription) {
      this.aliasChangedSubscription = this.aliasService.aliasChanged.subscribe(() => {
        this.leftActions = [];
      });
    }
  }

  ngOnDestroy(): void {
    if (this.aliasChangedSubscription) {
      this.aliasChangedSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line dot-notation
    if (changes['alias']) {
      this.leftActions = this.aliasHeaderService.getLeftActions(this.alias);
    }
  }

  isSearchVisible(): boolean {
    return this.showSearch;
  }

  clearSearch(): void {
    this.filters = [];
    this.filtersChanged.emit(this.filters);
    this.aliasTableService.loadAlias(this.filters, 1);
    this.leftActions = [];
  }

  sendSearch(currentFilters: Array<SearchBasicInfo>): void {
    this.filters = this.searchService.toFilters(currentFilters);
    this.filtersChanged.emit(this.filters);
    this.aliasTableService.loadAlias(this.filters, 1);
    this.leftActions = [];
  }

  hideSearch(): void {
    this.showSearch = false;
  }
}
